import { useNavigate } from 'react-router-dom'
import { useDocumentTitle } from '../../hooks/useDocumentTitle'
import { MainLayout } from '../../components/layouts/MainLayout'
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react'

export function EnrollmentCancelPage() {
  useDocumentTitle('申込キャンセル')
  const navigate = useNavigate()

  const handleRetry = () => {
    // pending_applyが残っていれば、マイページでプロンプトが表示される
    navigate('/mypage')
  }

  return (
    <MainLayout>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center">
          <XCircle className="mx-auto h-16 w-16 text-gray-400 mb-6" />
          <h1 className="text-3xl font-bold text-gray-900 mb-4">申込がキャンセルされました</h1>
          <p className="text-lg text-gray-600 mb-8">
            決済がキャンセルされたため、申込は完了していません。
            <br />
            もう一度申込を行う場合は、マイページからお手続きください。
          </p>

          <div className="space-y-4">
            <button
              onClick={handleRetry}
              className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition font-medium"
            >
              <RefreshCw className="h-5 w-5" />
              申込をやり直す
            </button>

            <button
              onClick={() => navigate('/mypage')}
              className="block w-full px-6 py-3 bg-white text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50 transition"
            >
              <div className="flex items-center justify-center gap-2">
                <ArrowLeft className="h-5 w-5" />
                マイページへ戻る
              </div>
            </button>
          </div>
        </div>

        <div className="mt-12 bg-gray-50 border border-gray-200 rounded-lg p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-3">お困りの場合</h2>
          <p className="text-sm text-gray-600 mb-3">
            決済に関するご質問やお困りの点がございましたら、サポートまでお問い合わせください。
          </p>
          <ul className="list-disc list-inside space-y-1 text-sm text-gray-600">
            <li>決済手続き中にエラーが発生した場合</li>
            <li>クレジットカード情報の入力に問題がある場合</li>
            <li>その他、申込に関するご質問</li>
          </ul>
        </div>
      </div>
    </MainLayout>
  )
}
